export default "__VITE_ASSET__CZyGU4LC__"